import * as React from "react";
import { RouteComponentProps } from "react-router";
import "./PsMobileTestPage.scss";
import { registerByAccessToken } from "../actions";
import { RootState } from "../../types";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { SESSION_USE_EMBEDDED_THEME } from "../../session/actions";
import history from "../../../history";

interface StoreProps {
  loading: boolean;
  errorMessage: string;
  isEmbeddedSession: boolean;
}

interface OwnState {
  token: string;
}

interface DispatchProps {
  registerByAccessToken: (token: string, backend: string) => void;
}

type Props = StoreProps & RouteComponentProps & DispatchProps;

class PsMobileTestPageContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    const tokenString = window.location.hash.substr(1);
    const token = tokenString.split("&")[0].split("=")[1];

    this.state = {
      token: token
    };
  }

  public componentDidMount() {
    window.sessionStorage.setItem(SESSION_USE_EMBEDDED_THEME, "true");
    if (!this.props.isEmbeddedSession) {
      if (this.state.token) this.props.registerByAccessToken(this.state.token, "perfectserve");
      history.replace(`/dashboard/`);
    }
  }

  public render() {
    const { errorMessage, loading } = this.props;
    return (
      <>
        <div className="ps">
          {loading && <LoadingFullScreen />}
          {errorMessage && (
            <div className="mt-25">
              <div>
                There is an issue with the provided credentials. Please contact your system
                administrator.
              </div>
              <div className="mt-10 error">{errorMessage}</div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    loading: state.psmobile.loading,
    errorMessage: state.psmobile.errorMessage,
    isEmbeddedSession: state.session.data.isEmbeddedSession
  }),
  {
    registerByAccessToken
  }
)(PsMobileTestPageContainer);
